import React from 'react';

import styled from 'styled-components';

import Header from 'common/Header';
import { useAppSelector } from 'store/hook';

const CommunityName = styled.div`
  font-size: 14px;
`;

const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  margin-right: 10px;
  background: linear-gradient(315deg, #5f5fff, #f05fff 50%, #ff5b98 0%);
`;

const AlertsHeader = () => {
  const { selectedCommunity } = useAppSelector((state) => state.global);

  return (
    <div data-test-id="alerts-header">
      <Header
        title="Alerts"
        breadcrumbs={<CommunityName data-test-id="alerts-header-community-name">{selectedCommunity?.name || ''}</CommunityName>}
        iconComponent={
          <IconContainer data-test-id="alerts-header-icon">
            <img src="/icons/alerts.svg" alt="alerts" height="20px" width="20px" />
          </IconContainer>
        }
      />
    </div>
  );
};

export default AlertsHeader;
